<script>
	import Feed from "./Feed.svelte";
	import Upload from "./Upload.svelte";
	import UploadHosted from "./UploadHosted.svelte";
	import Download from "./Download.svelte";
	import { Route, router } from "tinro";
	import Localstorage from "./Localstorage.svelte";
	import Modal from "svelte-simple-modal";
	import { SvelteToast } from "@zerodevx/svelte-toast";
	import CreateStudyOld from "./CreateStudyOld.svelte";
	import CreateStudy from "./CreateStudy.svelte";
	import Whoops from "./Whoops.svelte";
	import About from "./About.svelte";
	import ViewForms from "./ViewForms.svelte";

	// questionnaire components
	import Demographics from "./forms/Demographics.svelte";
	import CRT from "./forms/CRT.svelte";
	import SES from "./forms/SES.svelte";
	import SocialMediaUse from "./forms/SocialMediaUse.svelte";
	import Lean from "./forms/Lean.svelte";
	import Final from "./forms/Final.svelte";
	import Importance from "./forms/Importance.svelte";
	import AOT from "./forms/AOT.svelte";
	import AttentionCheck from "./forms/AttentionCheck.svelte";
	import DesiredFrequency from "./forms/DesiredFrequency.svelte";
	import ExposureFrequency from "./forms/ExposureFrequency.svelte";
	import Concern from "./forms/Concern.svelte";
	import Fatigue from "./forms/Fatigue.svelte";
	import CustomEndMsg from "./forms/CustomEndMsg.svelte";

	// router.mode.hash(); // enables hash navigation method
	const options = {};
</script>

<svelte:head>
	<link rel="shortcut icon" href="/favicon.ico" type="image/png" />
</svelte:head>

<SvelteToast {options} />

<Route path="/">
	<Localstorage />
	<Modal><Feed /></Modal>
</Route>

<Route path="/download">
	<Download />
</Route>

<Route path="/upload">
	<Upload />
</Route>

<Route path="/upload-hosted">
	<UploadHosted />
</Route>

<Route path="/create-study-old">
	<Modal><CreateStudyOld /></Modal>
</Route>

<Route path="/create-study">
	<Modal><CreateStudy /></Modal>
</Route>

<Route path="/about">
	<About />
</Route>

<Route path="/viewforms">
	<ViewForms />
</Route>

<!-- one route per form/questionnaire -->
<Route path="/form/*">
	<Route path="/crt">
		<!-- <CRT redirectRoute="/form/lean" /> -->
		<CRT redirectRoute="" />
	</Route>

	<Route path="/lean">
		<!-- <Lean redirectRoute="/form/ses" /> -->
		<Lean redirectRoute="" />
	</Route>

	<Route path="/ses">
		<!-- <SES redirectRoute="/form/socialmediause" /> -->
		<SES redirectRoute="" />
	</Route>

	<Route path="/socialmediause">
		<!-- <SocialMediaUse redirectRoute="/form/form" /> -->
		<SocialMediaUse redirectRoute="" />
	</Route>

	<Route path="/form">
		<!-- <Demographics redirectRoute="/form/final" /> -->
		<Demographics redirectRoute="" />
	</Route>

	<Route path="/final">
		<Modal><Final /></Modal>
	</Route>

	<Route path="/imp">
		<Importance redirectRoute="" />
	</Route>

	<Route path="/aot">
		<AOT redirectRoute="" />
	</Route>

	<Route path="/ac">
		<AttentionCheck redirectRoute="" />
	</Route>

	<Route path="/def">
		<DesiredFrequency redirectRoute="" />
	</Route>

	<Route path="/exp">
		<ExposureFrequency redirectRoute="" />
	</Route>

	<Route path="/ccn">
		<Concern redirectRoute="" />
	</Route>

	<Route path="/ftg">
		<Fatigue redirectRoute="" />
	</Route>

	<Route path="/custom-msg">
		<Modal><CustomEndMsg redirectRoute="" /></Modal>
	</Route>
</Route>

<Route fallback>
	<Whoops />
</Route>